export default "__VITE_ASSET__CXbyfCtX__"